 <!--==========================
      About Us Section
    ============================-->
    <section id="about" >
      <div class="container">

        <header class="section-header">
          <h1 style="text-align: center;">About Us</h1>
        
        </header>

        <div class="row about-container">

          <div class="col-lg-6 content order-lg-1 order-2">
           
            <div class="icon-box wow fadeInUp">
            
              <h4 class="title"><a href="">Who we are</a></h4>
              <p class="description" >Software Solutions, Software Solution For Mining Billing, Shree Core Banking Software. 
                Apart from these we also offer Marketing Management Software. All these applications are developed 
                on modern platform that are compatible with all kinds of computer systems. The software developed by us are user-friendly, 
                comprehensive and flexible. Across varied sectors such as manufacturing & service industries, banks, 
                libraries and transportation companies, our services are widely applicable. Our competency lies in offering credit society software solutions,
                 Retail Banking software solutions, tailor made software solutions, accounting / inventory software solutions and on-line crusher management software.
                  We have a team of dexterous software engineers that develop tailored software for our clients. Keeping quality as the top agenda,
                   we ensure that our customer’s benefit from our services. We are Exporter & Service Provider in  U.K, India & America.
                    Further, we have garnered a huge clientele, which includes MNGL, Hyundai and large Mini Banking sector.
                     We have 27 + years experience in Software development area.</p>
            </div>

            <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
            
              <h4 class="title"><a href="">Director's </a></h4>
              <p class="description"><b>Shrinivas Khot C.E.O., Co-founder</b> </p>
                  <p class="description">
                  Being the founder of the company, it was his brainchild to build the company as one of the best choices of software development companies in USA. Shrinivas is responsible for setting up the business and marketing strategies, business development and client relationship management.
                  
                  Shrinivas is an past Executive Committee member of Software Exporters’ Association of Pune ( NGO) and past Chairman of Shree Computer Education Society ( NGO) in India which help computer education in rural area. Shrinivas is responsible for setting up the business and marketing strategies, business development and client relationship management.</p>
            </div>

         

          </div>
          <div class="col-lg-6 content order-lg-1 order-2">

          <div class="background order-lg-2 order-1 wow fadeInUp">
            <img src="../assets/img/about-img.svg" class="img-fluid" alt="">
          </div>

          <div class="icon-box wow fadeInUp" data-wow-delay="0.2s">
            
            <p style="margin: 30px">
              -
            </p>
              <p class="description"><b>Debnath Mondal, Co-founder</b> </p>
                  <p class="description">
                      Agile Transformation Leader with three decades of IT experience and
                      over 14 years of Agile experience. Championed enterprise-wide change
                      using SAFe and LeSS frameworks. Promoted organizational
                      understanding and implementation of Agile roles and agility through
                      workshops, mentoring, and coaching. Collaborated with other coaches
                      and used analytics to accelerate transformation. 
                      Expert in combining technical and management experience with Agile 
                      methodologies to optimize operations and deliver results           </div>


        </div>
        </div>

        

      

      </div>
    </section><!-- #about -->